'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var $tyW6A$react = require('react');
var react = require('@emotion/react');
var icons = require('@otrium/icons');
var core = require('@otrium/core');
var styled = require('@emotion/styled');
var nanoid = require('nanoid');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var $tyW6A$react__default = /*#__PURE__*/_interopDefaultLegacy($tyW6A$react);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value1, defaultValue, onChange) {
  var _$6imuh$useState = $tyW6A$react.useState(value1 || defaultValue),
    _$6imuh$useState2 = _slicedToArray(_$6imuh$useState, 2),
    stateValue = _$6imuh$useState2[0],
    setStateValue = _$6imuh$useState2[1];
  var ref = $tyW6A$react.useRef(value1 !== undefined);
  var wasControlled = ref.current;
  var isControlled = value1 !== undefined;
  // Internal state reference for useCallback
  var stateRef = $tyW6A$react.useRef(stateValue);
  if (wasControlled !== isControlled) console.warn("WARN: A component changed from ".concat(wasControlled ? 'controlled' : 'uncontrolled', " to ").concat(isControlled ? 'controlled' : 'uncontrolled', "."));
  ref.current = isControlled;
  var setValue = $tyW6A$react.useCallback(function (value2) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    var onChangeCaller = function onChangeCaller(value) {
      if (onChange) {
        for (var _len2 = arguments.length, onChangeArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          onChangeArgs[_key2 - 1] = arguments[_key2];
        }
        if (!Object.is(stateRef.current, value)) onChange.apply(void 0, [value].concat(onChangeArgs));
      }
      if (!isControlled) stateRef.current = value;
    };
    if (typeof value2 === 'function') {
      console.warn('We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320');
      // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
      // when someone using useControlledState calls setControlledState(myFunc)
      // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
      // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
      // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
      var updateFunction = function updateFunction(oldValue) {
        for (var _len3 = arguments.length, functionArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          functionArgs[_key3 - 1] = arguments[_key3];
        }
        var interceptedValue = value2.apply(void 0, [isControlled ? stateRef.current : oldValue].concat(functionArgs));
        onChangeCaller.apply(void 0, [interceptedValue].concat(args));
        if (!isControlled) return interceptedValue;
        return oldValue;
      };
      setStateValue(updateFunction);
    } else {
      if (!isControlled) setStateValue(value2);
      onChangeCaller.apply(void 0, [value2].concat(args));
    }
  }, [isControlled, onChange]);
  // If a controlled component's value prop changes, we need to update stateRef
  if (isControlled) stateRef.current = value1;else value1 = stateValue;
  return [value1, setValue];
}

// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
var $704cf1d3b684cc5c$var$defaultContext = {
  prefix: String(Math.round(Math.random() * 10000000000)),
  current: 0
};
var $704cf1d3b684cc5c$var$SSRContext = /*#__PURE__*/$tyW6A$react__default["default"].createContext($704cf1d3b684cc5c$var$defaultContext);
var $704cf1d3b684cc5c$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
function $704cf1d3b684cc5c$export$619500959fc48b26(defaultId) {
  var ctx = $tyW6A$react.useContext($704cf1d3b684cc5c$var$SSRContext);
  // If we are rendering in a non-DOM environment, and there's no SSRProvider,
  // provide a warning to hint to the developer to add one.
  if (ctx === $704cf1d3b684cc5c$var$defaultContext && !$704cf1d3b684cc5c$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
  return $tyW6A$react.useMemo(function () {
    return defaultId || "react-aria".concat(ctx.prefix, "-").concat(++ctx.current);
  }, [defaultId]);
}

function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == _typeof(e)) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}

var $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof window !== 'undefined' ? $tyW6A$react__default["default"].useLayoutEffect : function () {};
var $bdb11010cef70236$var$idsUpdaterMap = new Map();
function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
  var _$12uGp$useState = $tyW6A$react.useState(defaultId),
    _$12uGp$useState2 = _slicedToArray(_$12uGp$useState, 2),
    value = _$12uGp$useState2[0],
    setValue = _$12uGp$useState2[1];
  var nextId = $tyW6A$react.useRef(null);
  var res = $704cf1d3b684cc5c$export$619500959fc48b26(value);
  var updateValue = $tyW6A$react.useCallback(function (val) {
    nextId.current = val;
  }, []);
  $bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function () {
    var r = res;
    return function () {
      $bdb11010cef70236$var$idsUpdaterMap["delete"](r);
    };
  }, [res]);
  // This cannot cause an infinite loop because the ref is updated first.
  // eslint-disable-next-line
  $tyW6A$react.useEffect(function () {
    var newId = nextId.current;
    if (newId) {
      nextId.current = null;
      setValue(newId);
    }
  });
  return res;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
  if (idA === idB) return idA;
  var setIdA = $bdb11010cef70236$var$idsUpdaterMap.get(idA);
  if (setIdA) {
    setIdA(idB);
    return idB;
  }
  var setIdB = $bdb11010cef70236$var$idsUpdaterMap.get(idB);
  if (setIdB) {
    setIdB(idA);
    return idA;
  }
  return idB;
}
function $ff5963eb1fccf552$export$e08e3b67e392101e() {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }
  return function () {
    for (var _i = 0, _callbacks = callbacks; _i < _callbacks.length; _i++) {
      var callback = _callbacks[_i];
      if (typeof callback === 'function') callback.apply(void 0, arguments);
    }
  };
}
function $3ef42575df84b30b$export$9d1611c77c2fe928() {
  // Start with a base clone of the first argument. This is a lot faster than starting
  // with an empty object and adding properties as we go.
  var result = _objectSpread2({}, arguments.length <= 0 ? undefined : arguments[0]);
  for (var i = 1; i < arguments.length; i++) {
    var props = i < 0 || arguments.length <= i ? undefined : arguments[i];
    for (var key in props) {
      var a = result[key];
      var b = props[key];
      // Chain events
      if (typeof a === 'function' && typeof b === 'function' &&
      // This is a lot faster than a regex.
      key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) >= /* 'A' */65 && key.charCodeAt(2) <= /* 'Z' */90) result[key] = $ff5963eb1fccf552$export$e08e3b67e392101e(a, b);else if ((key === 'className' || key === 'UNSAFE_className') && typeof a === 'string' && typeof b === 'string') result[key] = clsx(a, b);else if (key === 'id' && a && b) result.id = $bdb11010cef70236$export$cd8c9cb68f842629(a, b);else result[key] = b !== undefined ? b : a;
    }
  }
  return result;
}
var $65484d02dcb7eb3e$var$DOMPropNames = new Set(['id']);
var $65484d02dcb7eb3e$var$labelablePropNames = new Set(['aria-label', 'aria-labelledby', 'aria-describedby', 'aria-details']);
var $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var labelable = opts.labelable,
    propNames = opts.propNames;
  var filteredProps = {};
  for (var prop in props) if (Object.prototype.hasOwnProperty.call(props, prop) && ($65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $65484d02dcb7eb3e$var$labelablePropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
  return filteredProps;
}
function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
  if ($7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
    preventScroll: true
  });else {
    var scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
    element.focus();
    $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
  }
}
var $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached = false;
    try {
      var focusElem = document.createElement('div');
      focusElem.focus({
        get preventScroll() {
          $7215afc6de606d6b$var$supportsPreventScrollCached = true;
          return true;
        }
      });
    } catch (e) {
      // Ignore
    }
  }
  return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(element) {
  var parent = element.parentNode;
  var scrollableElements = [];
  var rootScrollingElement = document.scrollingElement || document.documentElement;
  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
      element: parent,
      scrollTop: parent.scrollTop,
      scrollLeft: parent.scrollLeft
    });
    parent = parent.parentNode;
  }
  if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
    element: rootScrollingElement,
    scrollTop: rootScrollingElement.scrollTop,
    scrollLeft: rootScrollingElement.scrollLeft
  });
  return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
  var _iterator = _createForOfIteratorHelper(scrollableElements),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
        element = _step$value.element,
        scrollTop = _step$value.scrollTop,
        scrollLeft = _step$value.scrollLeft;
      element.scrollTop = scrollTop;
      element.scrollLeft = scrollLeft;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
var $bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
var $bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
  if (typeof window === 'undefined') return;
  var onTransitionStart = function onTransitionStart(e) {
    // Add the transitioning property to the list for this element.
    var transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
    if (!transitions) {
      transitions = new Set();
      $bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
      // The transitioncancel event must be registered on the element itself, rather than as a global
      // event. This enables us to handle when the node is deleted from the document while it is transitioning.
      // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
      e.target.addEventListener('transitioncancel', onTransitionEnd);
    }
    transitions.add(e.propertyName);
  };
  var onTransitionEnd = function onTransitionEnd(e) {
    // Remove property from list of transitioning properties.
    var properties = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
    if (!properties) return;
    properties["delete"](e.propertyName);
    // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
    if (properties.size === 0) {
      e.target.removeEventListener('transitioncancel', onTransitionEnd);
      $bbed8b41f857bcc0$var$transitionsByElement["delete"](e.target);
    }
    // If no transitioning elements, call all of the queued callbacks.
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
      var _iterator2 = _createForOfIteratorHelper($bbed8b41f857bcc0$var$transitionCallbacks),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var cb = _step2.value;
          cb();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      $bbed8b41f857bcc0$var$transitionCallbacks.clear();
    }
  };
  document.body.addEventListener('transitionrun', onTransitionStart);
  document.body.addEventListener('transitionend', onTransitionEnd);
}
if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') $bbed8b41f857bcc0$var$setupGlobalEvents();else document.addEventListener('DOMContentLoaded', $bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
  // Wait one frame to see if an animation starts, e.g. a transition on mount.
  requestAnimationFrame(function () {
    // If no transitions are running, call the function immediately.
    // Otherwise, add it to a list of callbacks to run at the end of the animation.
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
  });
}
function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
  var globalListeners = $tyW6A$react.useRef(new Map());
  var addGlobalListener = $tyW6A$react.useCallback(function (eventTarget, type, listener, options) {
    // Make sure we remove the listener after it is called with the `once` option.
    var fn = (options === null || options === void 0 ? void 0 : options.once) ? function () {
      globalListeners.current["delete"](listener);
      listener.apply(void 0, arguments);
    } : listener;
    globalListeners.current.set(listener, {
      type: type,
      eventTarget: eventTarget,
      fn: fn,
      options: options
    });
    eventTarget.addEventListener(type, listener, options);
  }, []);
  var removeGlobalListener = $tyW6A$react.useCallback(function (eventTarget, type, listener, options) {
    var ref;
    var fn = ((ref = globalListeners.current.get(listener)) === null || ref === void 0 ? void 0 : ref.fn) || listener;
    eventTarget.removeEventListener(type, fn, options);
    globalListeners.current["delete"](listener);
  }, []);
  var removeAllGlobalListeners = $tyW6A$react.useCallback(function () {
    globalListeners.current.forEach(function (value, key) {
      removeGlobalListener(value.eventTarget, value.type, key, value.options);
    });
  }, [removeGlobalListener]);
  // eslint-disable-next-line arrow-body-style
  $tyW6A$react.useEffect(function () {
    return removeAllGlobalListeners;
  }, [removeAllGlobalListeners]);
  return {
    addGlobalListener: addGlobalListener,
    removeGlobalListener: removeGlobalListener,
    removeAllGlobalListeners: removeAllGlobalListeners
  };
}
function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function () {
    if (context && context.ref && ref) {
      context.ref.current = ref.current;
      return function () {
        context.ref.current = null;
      };
    }
  }, [context, ref]);
}
var $ef06256079686ba0$var$descriptionId = 0;
var $ef06256079686ba0$var$descriptionNodes = new Map();
function $ef06256079686ba0$export$f8aeda7b10753fa1(description) {
  var _$12uGp$useState5 = $tyW6A$react.useState(null),
    _$12uGp$useState6 = _slicedToArray(_$12uGp$useState5, 2),
    id1 = _$12uGp$useState6[0],
    setId = _$12uGp$useState6[1];
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function () {
    if (!description) return;
    var desc = $ef06256079686ba0$var$descriptionNodes.get(description);
    if (!desc) {
      var id = "react-aria-description-".concat($ef06256079686ba0$var$descriptionId++);
      setId(id);
      var node = document.createElement('div');
      node.id = id;
      node.style.display = 'none';
      node.textContent = description;
      document.body.appendChild(node);
      desc = {
        refCount: 0,
        element: node
      };
      $ef06256079686ba0$var$descriptionNodes.set(description, desc);
    } else setId(desc.element.id);
    desc.refCount++;
    return function () {
      if (--desc.refCount === 0) {
        desc.element.remove();
        $ef06256079686ba0$var$descriptionNodes["delete"](description);
      }
    };
  }, [description]);
  return {
    'aria-describedby': description ? id1 : undefined
  };
}
function $c87311424ea30a05$var$testPlatform(re) {
  var ref;
  return typeof window !== 'undefined' && window.navigator != null ? re.test(((ref = window.navigator['userAgentData']) === null || ref === void 0 ? void 0 : ref.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$export$9ac100e40613ea10() {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $c87311424ea30a05$export$186c6964ca17d99() {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $c87311424ea30a05$export$7bef049ce92e4224() {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) || $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $c87311424ea30a05$export$fedb369cb70207f1() {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}

var _excluded$2 = ["register"],
  _excluded2 = ["onPress", "onPressChange", "onPressStart", "onPressEnd", "onPressUp", "isDisabled", "isPressed", "preventFocusOnPress", "shouldCancelOnPointerExit", "allowTextSelectionOnPress", "ref"];

// Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
var $14c0b72509d70225$var$state = 'default';
var $14c0b72509d70225$var$savedUserSelect = '';
var $14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $14c0b72509d70225$export$16a4697467175487(target) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state === 'default') {
      $14c0b72509d70225$var$savedUserSelect = document.documentElement.style.webkitUserSelect;
      document.documentElement.style.webkitUserSelect = 'none';
    }
    $14c0b72509d70225$var$state = 'disabled';
  } else if (target instanceof HTMLElement || target instanceof SVGElement) {
    // If not iOS, store the target's original user-select and change to user-select: none
    // Ignore state since it doesn't apply for non iOS
    $14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
    target.style.userSelect = 'none';
  }
}
function $14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    // If the state is already default, there's nothing to do.
    // If it is restoring, then there's no need to queue a second restore.
    if ($14c0b72509d70225$var$state !== 'disabled') return;
    $14c0b72509d70225$var$state = 'restoring';
    // There appears to be a delay on iOS where selection still might occur
    // after pointer up, so wait a bit before removing user-select.
    setTimeout(function () {
      // Wait for any CSS transitions to complete so we don't recompute style
      // for the whole page in the middle of the animation and cause jank.
      $bbed8b41f857bcc0$export$24490316f764c430(function () {
        // Avoid race conditions
        if ($14c0b72509d70225$var$state === 'restoring') {
          if (document.documentElement.style.webkitUserSelect === 'none') document.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || '';
          $14c0b72509d70225$var$savedUserSelect = '';
          $14c0b72509d70225$var$state = 'default';
        }
      });
    }, 300);
  } else if (target instanceof HTMLElement || target instanceof SVGElement)
    // If not iOS, restore the target's original user-select if any
    // Ignore state since it doesn't apply for non iOS
    {
      if (target && $14c0b72509d70225$var$modifiedElementMap.has(target)) {
        var targetOldUserSelect = $14c0b72509d70225$var$modifiedElementMap.get(target);
        if (target.style.userSelect === 'none') target.style.userSelect = targetOldUserSelect;
        if (target.getAttribute('style') === '') target.removeAttribute('style');
        $14c0b72509d70225$var$modifiedElementMap["delete"](target);
      }
    }
}
function $8a9cb279dc87e130$export$60278871457622de(event) {
  // JAWS/NVDA with Firefox.
  if (event.mozInputSource === 0 && event.isTrusted) return true;
  return event.detail === 0 && !event.pointerType;
}
var $8a9cb279dc87e130$export$905e7fc544a71f36 = /*#__PURE__*/function () {
  function $8a9cb279dc87e130$export$905e7fc544a71f36(type, nativeEvent) {
    _classCallCheck(this, $8a9cb279dc87e130$export$905e7fc544a71f36);
    this.nativeEvent = nativeEvent;
    this.target = nativeEvent.target;
    this.currentTarget = nativeEvent.currentTarget;
    this.relatedTarget = nativeEvent.relatedTarget;
    this.bubbles = nativeEvent.bubbles;
    this.cancelable = nativeEvent.cancelable;
    this.defaultPrevented = nativeEvent.defaultPrevented;
    this.eventPhase = nativeEvent.eventPhase;
    this.isTrusted = nativeEvent.isTrusted;
    this.timeStamp = nativeEvent.timeStamp;
    this.type = type;
  }
  _createClass($8a9cb279dc87e130$export$905e7fc544a71f36, [{
    key: "isDefaultPrevented",
    value: function isDefaultPrevented() {
      return this.nativeEvent.defaultPrevented;
    }
  }, {
    key: "preventDefault",
    value: function preventDefault() {
      this.defaultPrevented = true;
      this.nativeEvent.preventDefault();
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      this.nativeEvent.stopPropagation();
      this.isPropagationStopped = function () {
        return true;
      };
    }
  }, {
    key: "isPropagationStopped",
    value: function isPropagationStopped() {
      return false;
    }
  }, {
    key: "persist",
    value: function persist() {}
  }]);
  return $8a9cb279dc87e130$export$905e7fc544a71f36;
}();
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
  var stateRef = $tyW6A$react.useRef({
    isFocused: false,
    onBlur: onBlur,
    observer: null
  });
  stateRef.current.onBlur = onBlur;
  // Clean up MutationObserver on unmount. See below.
  // eslint-disable-next-line arrow-body-style
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function () {
    var state = stateRef.current;
    return function () {
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
    };
  }, []);
  // This function is called during a React onFocus event.
  return $tyW6A$react.useCallback(function (e1) {
    // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
    // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
    // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
    // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
    if (e1.target instanceof HTMLButtonElement || e1.target instanceof HTMLInputElement || e1.target instanceof HTMLTextAreaElement || e1.target instanceof HTMLSelectElement) {
      stateRef.current.isFocused = true;
      var target = e1.target;
      var onBlurHandler = function onBlurHandler(e) {
        var
          // For backward compatibility, dispatch a (fake) React synthetic event.
          _current, ref;
        stateRef.current.isFocused = false;
        if (target.disabled) (ref = (_current = stateRef.current).onBlur) === null || ref === void 0 ? void 0 : ref.call(_current, new $8a9cb279dc87e130$export$905e7fc544a71f36('blur', e));
        // We no longer need the MutationObserver once the target is blurred.
        if (stateRef.current.observer) {
          stateRef.current.observer.disconnect();
          stateRef.current.observer = null;
        }
      };
      target.addEventListener('focusout', onBlurHandler, {
        once: true
      });
      stateRef.current.observer = new MutationObserver(function () {
        if (stateRef.current.isFocused && target.disabled) {
          stateRef.current.observer.disconnect();
          target.dispatchEvent(new FocusEvent('blur'));
          target.dispatchEvent(new FocusEvent('focusout', {
            bubbles: true
          }));
        }
      });
      stateRef.current.observer.observe(target, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }
  }, []);
}
var $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = /*#__PURE__*/$tyW6A$react__default["default"].createContext(null);
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = 'PressResponderContext';
function $f6c31cce2adf654f$var$usePressResponderContext(props) {
  // Consume context from <PressResponder> and merge with props.
  var context = $tyW6A$react.useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
  if (context) {
    var register = context.register,
      contextProps = _objectWithoutProperties(context, _excluded$2);
    props = $3ef42575df84b30b$export$9d1611c77c2fe928(contextProps, props);
    register();
  }
  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, props.ref);
  return props;
}
function $f6c31cce2adf654f$export$45712eceda6fad21(props) {
  var _$f6c31cce2adf654f$va = $f6c31cce2adf654f$var$usePressResponderContext(props),
    onPress1 = _$f6c31cce2adf654f$va.onPress,
    onPressChange1 = _$f6c31cce2adf654f$va.onPressChange,
    onPressStart1 = _$f6c31cce2adf654f$va.onPressStart,
    onPressEnd1 = _$f6c31cce2adf654f$va.onPressEnd,
    onPressUp1 = _$f6c31cce2adf654f$va.onPressUp,
    isDisabled1 = _$f6c31cce2adf654f$va.isDisabled,
    isPressedProp = _$f6c31cce2adf654f$va.isPressed,
    preventFocusOnPress = _$f6c31cce2adf654f$va.preventFocusOnPress,
    shouldCancelOnPointerExit = _$f6c31cce2adf654f$va.shouldCancelOnPointerExit,
    allowTextSelectionOnPress = _$f6c31cce2adf654f$va.allowTextSelectionOnPress;
    _$f6c31cce2adf654f$va.ref;
    var domProps = _objectWithoutProperties(_$f6c31cce2adf654f$va, _excluded2);
  var propsRef = $tyW6A$react.useRef(null);
  propsRef.current = {
    onPress: onPress1,
    onPressChange: onPressChange1,
    onPressStart: onPressStart1,
    onPressEnd: onPressEnd1,
    onPressUp: onPressUp1,
    isDisabled: isDisabled1,
    shouldCancelOnPointerExit: shouldCancelOnPointerExit
  };
  var _$bx7SL$useState = $tyW6A$react.useState(false),
    _$bx7SL$useState2 = _slicedToArray(_$bx7SL$useState, 2),
    isPressed = _$bx7SL$useState2[0],
    setPressed = _$bx7SL$useState2[1];
  var ref = $tyW6A$react.useRef({
    isPressed: false,
    ignoreEmulatedMouseEvents: false,
    ignoreClickAfterPress: false,
    didFirePressStart: false,
    activePointerId: null,
    target: null,
    isOverTarget: false,
    pointerType: null
  });
  var _$bx7SL$useGlobalList = $03deb23ff14920c4$export$4eaf04e54aa8eed6(),
    addGlobalListener = _$bx7SL$useGlobalList.addGlobalListener,
    removeAllGlobalListeners = _$bx7SL$useGlobalList.removeAllGlobalListeners;
  var pressProps1 = $tyW6A$react.useMemo(function () {
    var state = ref.current;
    var triggerPressStart = function triggerPressStart(originalEvent, pointerType) {
      var _propsRef$current = propsRef.current,
        onPressStart = _propsRef$current.onPressStart,
        onPressChange = _propsRef$current.onPressChange,
        isDisabled = _propsRef$current.isDisabled;
      if (isDisabled || state.didFirePressStart) return;
      if (onPressStart) onPressStart({
        type: 'pressstart',
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
      if (onPressChange) onPressChange(true);
      state.didFirePressStart = true;
      setPressed(true);
    };
    var triggerPressEnd = function triggerPressEnd(originalEvent, pointerType) {
      var wasPressed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var _propsRef$current2 = propsRef.current,
        onPressEnd = _propsRef$current2.onPressEnd,
        onPressChange = _propsRef$current2.onPressChange,
        onPress = _propsRef$current2.onPress,
        isDisabled = _propsRef$current2.isDisabled;
      if (!state.didFirePressStart) return;
      state.ignoreClickAfterPress = true;
      state.didFirePressStart = false;
      if (onPressEnd) onPressEnd({
        type: 'pressend',
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
      if (onPressChange) onPressChange(false);
      setPressed(false);
      if (onPress && wasPressed && !isDisabled) onPress({
        type: 'press',
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
    };
    var triggerPressUp = function triggerPressUp(originalEvent, pointerType) {
      var _propsRef$current3 = propsRef.current,
        onPressUp = _propsRef$current3.onPressUp,
        isDisabled = _propsRef$current3.isDisabled;
      if (isDisabled) return;
      if (onPressUp) onPressUp({
        type: 'pressup',
        pointerType: pointerType,
        target: originalEvent.currentTarget,
        shiftKey: originalEvent.shiftKey,
        metaKey: originalEvent.metaKey,
        ctrlKey: originalEvent.ctrlKey,
        altKey: originalEvent.altKey
      });
    };
    var cancel = function cancel(e) {
      if (state.isPressed) {
        if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
        state.isPressed = false;
        state.isOverTarget = false;
        state.activePointerId = null;
        state.pointerType = null;
        removeAllGlobalListeners();
        if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
      }
    };
    var pressProps = {
      onKeyDown: function onKeyDown(e) {
        if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
          if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
          e.stopPropagation();
          // If the event is repeating, it may have started on a different element
          // after which focus moved to the current element. Ignore these events and
          // only handle the first key down event.
          if (!state.isPressed && !e.repeat) {
            state.target = e.currentTarget;
            state.isPressed = true;
            triggerPressStart(e, 'keyboard');
            // Focus may move before the key up event, so register the event on the document
            // instead of the same element where the key down event occurred.
            addGlobalListener(document, 'keyup', onKeyUp, false);
          }
        } else if (e.key === 'Enter' && $f6c31cce2adf654f$var$isHTMLAnchorLink(e.currentTarget))
          // If the target is a link, we won't have handled this above because we want the default
          // browser behavior to open the link when pressing Enter. But we still need to prevent
          // default so that elements above do not also handle it (e.g. table row).
          e.stopPropagation();
      },
      onKeyUp: function onKeyUp(e) {
        if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && !e.repeat && e.currentTarget.contains(e.target)) triggerPressUp($f6c31cce2adf654f$var$createEvent(state.target, e), 'keyboard');
      },
      onClick: function onClick(e) {
        if (e && !e.currentTarget.contains(e.target)) return;
        if (e && e.button === 0) {
          e.stopPropagation();
          if (isDisabled1) e.preventDefault();
          // If triggered from a screen reader or by using element.click(),
          // trigger as if it were a keyboard click.
          if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && (state.pointerType === 'virtual' || $8a9cb279dc87e130$export$60278871457622de(e.nativeEvent))) {
            // Ensure the element receives focus (VoiceOver on iOS does not do this)
            if (!isDisabled1 && !preventFocusOnPress) $7215afc6de606d6b$export$de79e2c695e052f3(e.currentTarget);
            triggerPressStart(e, 'virtual');
            triggerPressUp(e, 'virtual');
            triggerPressEnd(e, 'virtual');
          }
          state.ignoreEmulatedMouseEvents = false;
          state.ignoreClickAfterPress = false;
        }
      }
    };
    var onKeyUp = function onKeyUp(e) {
      if (state.isPressed && $f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
        if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
        e.stopPropagation();
        state.isPressed = false;
        var target = e.target;
        triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), 'keyboard', state.target.contains(target));
        removeAllGlobalListeners();
        // If the target is a link, trigger the click method to open the URL,
        // but defer triggering pressEnd until onClick event handler.
        if (state.target instanceof HTMLElement && state.target.contains(target) && ($f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) || state.target.getAttribute('role') === 'link')) state.target.click();
      }
    };
    if (typeof PointerEvent !== 'undefined') {
      pressProps.onPointerDown = function (e) {
        // Only handle left clicks, and ignore events that bubbled through portals.
        if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
        // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
        // Ignore and let the onClick handler take care of it instead.
        // https://bugs.webkit.org/show_bug.cgi?id=222627
        // https://bugs.webkit.org/show_bug.cgi?id=223202
        if ($f6c31cce2adf654f$var$isVirtualPointerEvent(e.nativeEvent)) {
          state.pointerType = 'virtual';
          return;
        }
        // Due to browser inconsistencies, especially on mobile browsers, we prevent
        // default on pointer down and handle focusing the pressable element ourselves.
        if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
        state.pointerType = e.pointerType;
        e.stopPropagation();
        if (!state.isPressed) {
          state.isPressed = true;
          state.isOverTarget = true;
          state.activePointerId = e.pointerId;
          state.target = e.currentTarget;
          if (!isDisabled1 && !preventFocusOnPress) $7215afc6de606d6b$export$de79e2c695e052f3(e.currentTarget);
          if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
          triggerPressStart(e, state.pointerType);
          addGlobalListener(document, 'pointermove', onPointerMove, false);
          addGlobalListener(document, 'pointerup', onPointerUp, false);
          addGlobalListener(document, 'pointercancel', onPointerCancel, false);
        }
      };
      pressProps.onMouseDown = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        if (e.button === 0) {
          // Chrome and Firefox on touch Windows devices require mouse down events
          // to be canceled in addition to pointer events, or an extra asynchronous
          // focus event will be fired.
          if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
          e.stopPropagation();
        }
      };
      pressProps.onPointerUp = function (e) {
        // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
        if (!e.currentTarget.contains(e.target) || state.pointerType === 'virtual') return;
        // Only handle left clicks
        // Safari on iOS sometimes fires pointerup events, even
        // when the touch isn't over the target, so double check.
        if (e.button === 0 && $f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
      };
      // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
      // Use pointer move events instead to implement our own hit testing.
      // See https://bugs.webkit.org/show_bug.cgi?id=199803
      var onPointerMove = function onPointerMove(e) {
        if (e.pointerId !== state.activePointerId) return;
        if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
          if (!state.isOverTarget) {
            state.isOverTarget = true;
            triggerPressStart($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
          }
        } else if (state.isOverTarget) {
          state.isOverTarget = false;
          triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
        }
      };
      var onPointerUp = function onPointerUp(e) {
        if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0) {
          if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);else if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
          state.isPressed = false;
          state.isOverTarget = false;
          state.activePointerId = null;
          state.pointerType = null;
          removeAllGlobalListeners();
          if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
        }
      };
      var onPointerCancel = function onPointerCancel(e) {
        cancel(e);
      };
      pressProps.onDragStart = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
        cancel(e);
      };
    } else {
      pressProps.onMouseDown = function (e) {
        // Only handle left clicks
        if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
        // Due to browser inconsistencies, especially on mobile browsers, we prevent
        // default on mouse down and handle focusing the pressable element ourselves.
        if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
        e.stopPropagation();
        if (state.ignoreEmulatedMouseEvents) return;
        state.isPressed = true;
        state.isOverTarget = true;
        state.target = e.currentTarget;
        state.pointerType = $8a9cb279dc87e130$export$60278871457622de(e.nativeEvent) ? 'virtual' : 'mouse';
        if (!isDisabled1 && !preventFocusOnPress) $7215afc6de606d6b$export$de79e2c695e052f3(e.currentTarget);
        triggerPressStart(e, state.pointerType);
        addGlobalListener(document, 'mouseup', onMouseUp, false);
      };
      pressProps.onMouseEnter = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
          state.isOverTarget = true;
          triggerPressStart(e, state.pointerType);
        }
      };
      pressProps.onMouseLeave = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
          state.isOverTarget = false;
          triggerPressEnd(e, state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
        }
      };
      pressProps.onMouseUp = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType);
      };
      var onMouseUp = function onMouseUp(e) {
        // Only handle left clicks
        if (e.button !== 0) return;
        state.isPressed = false;
        removeAllGlobalListeners();
        if (state.ignoreEmulatedMouseEvents) {
          state.ignoreEmulatedMouseEvents = false;
          return;
        }
        if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);else if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
        state.isOverTarget = false;
      };
      pressProps.onTouchStart = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        var touch = $f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
        if (!touch) return;
        state.activePointerId = touch.identifier;
        state.ignoreEmulatedMouseEvents = true;
        state.isOverTarget = true;
        state.isPressed = true;
        state.target = e.currentTarget;
        state.pointerType = 'touch';
        // Due to browser inconsistencies, especially on mobile browsers, we prevent default
        // on the emulated mouse event and handle focusing the pressable element ourselves.
        if (!isDisabled1 && !preventFocusOnPress) $7215afc6de606d6b$export$de79e2c695e052f3(e.currentTarget);
        if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
        triggerPressStart(e, state.pointerType);
        addGlobalListener(window, 'scroll', onScroll, true);
      };
      pressProps.onTouchMove = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        if (!state.isPressed) return;
        var touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
        if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
          if (!state.isOverTarget) {
            state.isOverTarget = true;
            triggerPressStart(e, state.pointerType);
          }
        } else if (state.isOverTarget) {
          state.isOverTarget = false;
          triggerPressEnd(e, state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
        }
      };
      pressProps.onTouchEnd = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        if (!state.isPressed) return;
        var touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
        if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
          triggerPressUp(e, state.pointerType);
          triggerPressEnd(e, state.pointerType);
        } else if (state.isOverTarget) triggerPressEnd(e, state.pointerType, false);
        state.isPressed = false;
        state.activePointerId = null;
        state.isOverTarget = false;
        state.ignoreEmulatedMouseEvents = true;
        if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
        removeAllGlobalListeners();
      };
      pressProps.onTouchCancel = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        e.stopPropagation();
        if (state.isPressed) cancel(e);
      };
      var onScroll = function onScroll(e) {
        if (state.isPressed && e.target.contains(state.target)) cancel({
          currentTarget: state.target,
          shiftKey: false,
          ctrlKey: false,
          metaKey: false,
          altKey: false
        });
      };
      pressProps.onDragStart = function (e) {
        if (!e.currentTarget.contains(e.target)) return;
        cancel(e);
      };
    }
    return pressProps;
  }, [addGlobalListener, isDisabled1, preventFocusOnPress, removeAllGlobalListeners, allowTextSelectionOnPress]);
  // Remove user-select: none in case component unmounts immediately after pressStart
  // eslint-disable-next-line arrow-body-style
  $tyW6A$react.useEffect(function () {
    return function () {
      if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(ref.current.target);
    };
  }, [allowTextSelectionOnPress]);
  return {
    isPressed: isPressedProp || isPressed,
    pressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, pressProps1)
  };
}
function $f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
  return target.tagName === 'A' && target.hasAttribute('href');
}
function $f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
  var key = event.key,
    code = event.code;
  var element = currentTarget;
  var role = element.getAttribute('role');
  // Accessibility for keyboards. Space and Enter only.
  // "Spacebar" is for IE 11
  return (key === 'Enter' || key === ' ' || key === 'Spacebar' || code === 'Space') && !(element instanceof HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof HTMLTextAreaElement || element.isContentEditable) && (!$f6c31cce2adf654f$var$isHTMLAnchorLink(element) || role === 'button' && key !== 'Enter') &&
  // An element with role='link' should only trigger with Enter key
  !(role === 'link' && key !== 'Enter');
}
function $f6c31cce2adf654f$var$getTouchFromEvent(event) {
  var targetTouches = event.targetTouches;
  if (targetTouches.length > 0) return targetTouches[0];
  return null;
}
function $f6c31cce2adf654f$var$getTouchById(event, pointerId) {
  var changedTouches = event.changedTouches;
  for (var i = 0; i < changedTouches.length; i++) {
    var touch = changedTouches[i];
    if (touch.identifier === pointerId) return touch;
  }
  return null;
}
function $f6c31cce2adf654f$var$createEvent(target, e) {
  return {
    currentTarget: target,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey
  };
}
function $f6c31cce2adf654f$var$getPointClientRect(point) {
  var offsetX = point.width / 2 || point.radiusX || 0;
  var offsetY = point.height / 2 || point.radiusY || 0;
  return {
    top: point.clientY - offsetY,
    right: point.clientX + offsetX,
    bottom: point.clientY + offsetY,
    left: point.clientX - offsetX
  };
}
function $f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
  // check if they cannot overlap on x axis
  if (a.left > b.right || b.left > a.right) return false;
  // check if they cannot overlap on y axis
  if (a.top > b.bottom || b.top > a.bottom) return false;
  return true;
}
function $f6c31cce2adf654f$var$isOverTarget(point, target) {
  var rect = target.getBoundingClientRect();
  var pointRect = $f6c31cce2adf654f$var$getPointClientRect(point);
  return $f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $f6c31cce2adf654f$var$shouldPreventDefault(target) {
  // We cannot prevent default if the target is a draggable element.
  return !(target instanceof HTMLElement) || !target.draggable;
}
function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
  if (target instanceof HTMLInputElement) return !$f6c31cce2adf654f$var$isValidInputKey(target, key);
  if (target instanceof HTMLButtonElement) return target.type !== 'submit';
  return true;
}
var $f6c31cce2adf654f$var$nonTextInputTypes = new Set(['checkbox', 'radio', 'range', 'color', 'file', 'image', 'button', 'submit', 'reset']);
function $f6c31cce2adf654f$var$isValidInputKey(target, key) {
  // Only space should toggle checkboxes and radios, not enter.
  return target.type === 'checkbox' || target.type === 'radio' ? key === ' ' : $f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}
function $f6c31cce2adf654f$var$isVirtualPointerEvent(event) {
  // If the pointer size is zero, then we assume it's from a screen reader.
  // Android TalkBack double tap will sometimes return a event with width and height of 1
  // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
  // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
  // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
  // Talkback double tap from Windows Firefox touch screen press
  return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse';
}
function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
  var isDisabled = props.isDisabled,
    onFocusProp = props.onFocus,
    onBlurProp = props.onBlur,
    onFocusChange = props.onFocusChange;
  var onBlur = $tyW6A$react.useCallback(function (e) {
    if (e.target === e.currentTarget) {
      if (onBlurProp) onBlurProp(e);
      if (onFocusChange) onFocusChange(false);
      return true;
    }
  }, [onBlurProp, onFocusChange]);
  var onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  var onFocus = $tyW6A$react.useCallback(function (e) {
    if (e.target === e.currentTarget) {
      if (onFocusProp) onFocusProp(e);
      if (onFocusChange) onFocusChange(true);
      onSyntheticFocus(e);
    }
  }, [onFocusChange, onFocusProp, onSyntheticFocus]);
  return {
    focusProps: {
      onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
      onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : null
    }
  };
}
var $507fabe10e71c6fb$var$currentModality = null;
var $507fabe10e71c6fb$var$changeHandlers = new Set();
var $507fabe10e71c6fb$var$hasSetupGlobalListeners = false;
var $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
var $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
var $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
  Tab: true,
  Escape: true
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
  var _iterator = _createForOfIteratorHelper($507fabe10e71c6fb$var$changeHandlers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var handler = _step.value;
      handler(modality, e);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */
function $507fabe10e71c6fb$var$isValidKey(e) {
  // Control and Shift keys trigger when navigating back to the tab with keyboard.
  return !(e.metaKey || !$c87311424ea30a05$export$9ac100e40613ea10() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
  if ($507fabe10e71c6fb$var$isValidKey(e)) {
    $507fabe10e71c6fb$var$currentModality = 'keyboard';
    $507fabe10e71c6fb$var$triggerChangeHandlers('keyboard', e);
  }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e) {
  $507fabe10e71c6fb$var$currentModality = 'pointer';
  if (e.type === 'mousedown' || e.type === 'pointerdown') {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$triggerChangeHandlers('pointer', e);
  }
}
function $507fabe10e71c6fb$var$handleClickEvent(e) {
  if ($8a9cb279dc87e130$export$60278871457622de(e)) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$currentModality = 'virtual';
  }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e) {
  // Firefox fires two extra focus events when the user first clicks into an iframe:
  // first on the window, then on the document. We ignore these events so they don't
  // cause keyboard focus rings to appear.
  if (e.target === window || e.target === document) return;
  // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
  // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
  if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
    $507fabe10e71c6fb$var$currentModality = 'virtual';
    $507fabe10e71c6fb$var$triggerChangeHandlers('virtual', e);
  }
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
  // When the window is blurred, reset state. This is necessary when tabbing out of the window,
  // for example, since a subsequent focus event won't be fired.
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */
function $507fabe10e71c6fb$var$setupGlobalFocusEvents() {
  if (typeof window === 'undefined' || $507fabe10e71c6fb$var$hasSetupGlobalListeners) return;
  // Programmatic focus() calls shouldn't affect the current input modality.
  // However, we need to detect other cases when a focus event occurs without
  // a preceding user event (e.g. screen reader focus). Overriding the focus
  // method on HTMLElement.prototype is a bit hacky, but works.
  var focus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function () {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    focus.apply(this, arguments);
  };
  document.addEventListener('keydown', $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  document.addEventListener('keyup', $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  document.addEventListener('click', $507fabe10e71c6fb$var$handleClickEvent, true);
  // Register focus events on the window so they are sure to happen
  // before React's event listeners (registered on the document).
  window.addEventListener('focus', $507fabe10e71c6fb$var$handleFocusEvent, true);
  window.addEventListener('blur', $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== 'undefined') {
    document.addEventListener('pointerdown', $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener('pointermove', $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener('pointerup', $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else {
    document.addEventListener('mousedown', $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener('mousemove', $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener('mouseup', $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  $507fabe10e71c6fb$var$hasSetupGlobalListeners = true;
}
if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') $507fabe10e71c6fb$var$setupGlobalFocusEvents();else document.addEventListener('DOMContentLoaded', $507fabe10e71c6fb$var$setupGlobalFocusEvents);
}
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
  return $507fabe10e71c6fb$var$currentModality !== 'pointer';
}
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
  return $507fabe10e71c6fb$var$currentModality;
}
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */
function $507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
  return !(isTextInput && modality === 'keyboard' && e instanceof KeyboardEvent && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(fn, deps, opts) {
  $507fabe10e71c6fb$var$setupGlobalFocusEvents();
  $tyW6A$react.useEffect(function () {
    var handler = function handler(modality, e) {
      if (!$507fabe10e71c6fb$var$isKeyboardFocusEvent(opts === null || opts === void 0 ? void 0 : opts.isTextInput, modality, e)) return;
      fn($507fabe10e71c6fb$export$b9b3dfddab17db27());
    };
    $507fabe10e71c6fb$var$changeHandlers.add(handler);
    return function () {
      $507fabe10e71c6fb$var$changeHandlers["delete"](handler);
    };
  }, deps);
}
function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
  var isDisabled = props.isDisabled,
    onBlurWithin = props.onBlurWithin,
    onFocusWithin = props.onFocusWithin,
    onFocusWithinChange = props.onFocusWithinChange;
  var state = $tyW6A$react.useRef({
    isFocusWithin: false
  });
  var onBlur = $tyW6A$react.useCallback(function (e) {
    // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
    // when moving focus inside the element. Only trigger if the currentTarget doesn't
    // include the relatedTarget (where focus is moving).
    if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
      state.current.isFocusWithin = false;
      if (onBlurWithin) onBlurWithin(e);
      if (onFocusWithinChange) onFocusWithinChange(false);
    }
  }, [onBlurWithin, onFocusWithinChange, state]);
  var onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  var onFocus = $tyW6A$react.useCallback(function (e) {
    if (!state.current.isFocusWithin) {
      if (onFocusWithin) onFocusWithin(e);
      if (onFocusWithinChange) onFocusWithinChange(true);
      state.current.isFocusWithin = true;
      onSyntheticFocus(e);
    }
  }, [onFocusWithin, onFocusWithinChange, onSyntheticFocus]);
  if (isDisabled) return {
    focusWithinProps: {
      onFocus: null,
      onBlur: null
    }
  };
  return {
    focusWithinProps: {
      onFocus: onFocus,
      onBlur: onBlur
    }
  };
}

// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
var $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
var $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
  $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
  // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
  // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
  // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
  // the distant future because a user previously touched the element.
  setTimeout(function () {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
  }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(e) {
  if (e.pointerType === 'touch') $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
  if (typeof document === 'undefined') return;
  if (typeof PointerEvent !== 'undefined') document.addEventListener('pointerup', $6179b936705e76d3$var$handleGlobalPointerEvent);else document.addEventListener('touchend', $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  $6179b936705e76d3$var$hoverCount++;
  return function () {
    $6179b936705e76d3$var$hoverCount--;
    if ($6179b936705e76d3$var$hoverCount > 0) return;
    if (typeof PointerEvent !== 'undefined') document.removeEventListener('pointerup', $6179b936705e76d3$var$handleGlobalPointerEvent);else document.removeEventListener('touchend', $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  };
}
function $6179b936705e76d3$export$ae780daf29e6d456(props) {
  var onHoverStart = props.onHoverStart,
    onHoverChange = props.onHoverChange,
    onHoverEnd = props.onHoverEnd,
    isDisabled = props.isDisabled;
  var _$bx7SL$useState7 = $tyW6A$react.useState(false),
    _$bx7SL$useState8 = _slicedToArray(_$bx7SL$useState7, 2),
    isHovered = _$bx7SL$useState8[0],
    setHovered = _$bx7SL$useState8[1];
  var state = $tyW6A$react.useRef({
    isHovered: false,
    ignoreEmulatedMouseEvents: false,
    pointerType: '',
    target: null
  }).current;
  $tyW6A$react.useEffect($6179b936705e76d3$var$setupGlobalTouchEvents, []);
  var _$bx7SL$useMemo = $tyW6A$react.useMemo(function () {
      var triggerHoverStart = function triggerHoverStart(event, pointerType) {
        state.pointerType = pointerType;
        if (isDisabled || pointerType === 'touch' || state.isHovered || !event.currentTarget.contains(event.target)) return;
        state.isHovered = true;
        var target = event.currentTarget;
        state.target = target;
        if (onHoverStart) onHoverStart({
          type: 'hoverstart',
          target: target,
          pointerType: pointerType
        });
        if (onHoverChange) onHoverChange(true);
        setHovered(true);
      };
      var triggerHoverEnd = function triggerHoverEnd(event, pointerType) {
        state.pointerType = '';
        state.target = null;
        if (pointerType === 'touch' || !state.isHovered) return;
        state.isHovered = false;
        var target = event.currentTarget;
        if (onHoverEnd) onHoverEnd({
          type: 'hoverend',
          target: target,
          pointerType: pointerType
        });
        if (onHoverChange) onHoverChange(false);
        setHovered(false);
      };
      var hoverProps = {};
      if (typeof PointerEvent !== 'undefined') {
        hoverProps.onPointerEnter = function (e) {
          if ($6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
          triggerHoverStart(e, e.pointerType);
        };
        hoverProps.onPointerLeave = function (e) {
          if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
        };
      } else {
        hoverProps.onTouchStart = function () {
          state.ignoreEmulatedMouseEvents = true;
        };
        hoverProps.onMouseEnter = function (e) {
          if (!state.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, 'mouse');
          state.ignoreEmulatedMouseEvents = false;
        };
        hoverProps.onMouseLeave = function (e) {
          if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, 'mouse');
        };
      }
      return {
        hoverProps: hoverProps,
        triggerHoverEnd: triggerHoverEnd
      };
    }, [onHoverStart, onHoverChange, onHoverEnd, isDisabled, state]),
    hoverProps1 = _$bx7SL$useMemo.hoverProps,
    triggerHoverEnd1 = _$bx7SL$useMemo.triggerHoverEnd;
  $tyW6A$react.useEffect(function () {
    // Call the triggerHoverEnd as soon as isDisabled changes to true
    // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
    if (isDisabled) triggerHoverEnd1({
      currentTarget: state.target
    }, state.pointerType);
  }, [isDisabled]);
  return {
    hoverProps: hoverProps1,
    isHovered: isHovered
  };
}
function $93925083ecbb358c$export$48d1ea6320830260(handler) {
  if (!handler) return;
  var shouldStopPropagation = true;
  return function (e) {
    var event = _objectSpread2(_objectSpread2({}, e), {}, {
      preventDefault: function preventDefault() {
        e.preventDefault();
      },
      isDefaultPrevented: function isDefaultPrevented() {
        return e.isDefaultPrevented();
      },
      stopPropagation: function stopPropagation() {
        console.error('stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.');
      },
      continuePropagation: function continuePropagation() {
        shouldStopPropagation = false;
      }
    });
    handler(event);
    if (shouldStopPropagation) e.stopPropagation();
  };
}
function $46d819fcbaf35654$export$8f71654801c2f7cd(props) {
  return {
    keyboardProps: props.isDisabled ? {} : {
      onKeyDown: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
      onKeyUp: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
    }
  };
}
var $8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $8a26561d2877236e$export$c24ed0104d07eab9(props) {
  var isDisabled = props.isDisabled,
    onLongPressStart = props.onLongPressStart,
    onLongPressEnd = props.onLongPressEnd,
    onLongPress = props.onLongPress,
    _props$threshold = props.threshold,
    threshold = _props$threshold === void 0 ? $8a26561d2877236e$var$DEFAULT_THRESHOLD : _props$threshold,
    accessibilityDescription = props.accessibilityDescription;
  var timeRef = $tyW6A$react.useRef(null);
  var _$bx7SL$useGlobalList3 = $03deb23ff14920c4$export$4eaf04e54aa8eed6(),
    addGlobalListener = _$bx7SL$useGlobalList3.addGlobalListener,
    removeGlobalListener = _$bx7SL$useGlobalList3.removeGlobalListener;
  var _$f6c31cce2adf654f$ex2 = $f6c31cce2adf654f$export$45712eceda6fad21({
      isDisabled: isDisabled,
      onPressStart: function onPressStart(e1) {
        if (e1.pointerType === 'mouse' || e1.pointerType === 'touch') {
          if (onLongPressStart) onLongPressStart(_objectSpread2(_objectSpread2({}, e1), {}, {
            type: 'longpressstart'
          }));
          timeRef.current = setTimeout(function () {
            // Prevent other usePress handlers from also handling this event.
            e1.target.dispatchEvent(new PointerEvent('pointercancel', {
              bubbles: true
            }));
            if (onLongPress) onLongPress(_objectSpread2(_objectSpread2({}, e1), {}, {
              type: 'longpress'
            }));
            timeRef.current = null;
          }, threshold);
          // Prevent context menu, which may be opened on long press on touch devices
          if (e1.pointerType === 'touch') {
            var onContextMenu = function onContextMenu(e) {
              e.preventDefault();
            };
            addGlobalListener(e1.target, 'contextmenu', onContextMenu, {
              once: true
            });
            addGlobalListener(window, 'pointerup', function () {
              // If no contextmenu event is fired quickly after pointerup, remove the handler
              // so future context menu events outside a long press are not prevented.
              setTimeout(function () {
                removeGlobalListener(e1.target, 'contextmenu', onContextMenu);
              }, 30);
            }, {
              once: true
            });
          }
        }
      },
      onPressEnd: function onPressEnd(e) {
        if (timeRef.current) clearTimeout(timeRef.current);
        if (onLongPressEnd && (e.pointerType === 'mouse' || e.pointerType === 'touch')) onLongPressEnd(_objectSpread2(_objectSpread2({}, e), {}, {
          type: 'longpressend'
        }));
      }
    }),
    pressProps = _$f6c31cce2adf654f$ex2.pressProps;
  var descriptionProps = $ef06256079686ba0$export$f8aeda7b10753fa1(onLongPress && !isDisabled ? accessibilityDescription : null);
  return {
    longPressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, descriptionProps)
  };
}

var _excluded$1 = ["ref"];
function $6a99195332edec8b$export$80f3e147d781571c(element) {
  // If the user is interacting with a virtual cursor, e.g. screen reader, then
  // wait until after any animated transitions that are currently occurring on
  // the page before shifting focus. This avoids issues with VoiceOver on iOS
  // causing the page to scroll when moving focus if the element is transitioning
  // from off the screen.
  if ($507fabe10e71c6fb$export$630ff653c5ada6a9() === 'virtual') {
    var lastFocusedElement = document.activeElement;
    $bbed8b41f857bcc0$export$24490316f764c430(function () {
      // If focus did not move and the element is still in the document, focus it.
      if (document.activeElement === lastFocusedElement && document.contains(element)) $7215afc6de606d6b$export$de79e2c695e052f3(element);
    });
  } else $7215afc6de606d6b$export$de79e2c695e052f3(element);
}
function $9bf71ea28793e738$var$isElementInScope(element, scope) {
  return scope.some(function (node) {
    return node.contains(element);
  });
}
var $9bf71ea28793e738$var$Tree = /*#__PURE__*/function () {
  function $9bf71ea28793e738$var$Tree() {
    _classCallCheck(this, $9bf71ea28793e738$var$Tree);
    this.fastMap = new Map();
    this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    });
    this.fastMap.set(null, this.root);
  }
  _createClass($9bf71ea28793e738$var$Tree, [{
    key: "size",
    get: function get() {
      return this.fastMap.size;
    }
  }, {
    key: "getTreeNode",
    value: function getTreeNode(data) {
      return this.fastMap.get(data);
    }
  }, {
    key: "addTreeNode",
    value: function addTreeNode(scopeRef, parent, nodeToRestore) {
      var parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
      var node = new $9bf71ea28793e738$var$TreeNode({
        scopeRef: scopeRef
      });
      parentNode.addChild(node);
      node.parent = parentNode;
      this.fastMap.set(scopeRef, node);
      if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
  }, {
    key: "removeTreeNode",
    value: function removeTreeNode(scopeRef) {
      // never remove the root
      if (scopeRef === null) return;
      var node = this.fastMap.get(scopeRef);
      var parentNode = node.parent;
      // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
      // if we are, then replace the siblings restore with the restore from the scope we're removing
      var _iterator2 = _createForOfIteratorHelper(this.traverse()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var current = _step2.value;
          if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var children = node.children;
      parentNode.removeChild(node);
      if (children.length > 0) children.forEach(function (child) {
        return parentNode.addChild(child);
      });
      this.fastMap["delete"](node.scopeRef);
    }
    // Pre Order Depth First
  }, {
    key: "traverse",
    value: function traverse() {
      var _this = this;
      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.root;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _iterator3, _step3, child;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(node.scopeRef != null)) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return node;
            case 3:
              if (!(node.children.length > 0)) {
                _context.next = 20;
                break;
              }
              _iterator3 = _createForOfIteratorHelper(node.children);
              _context.prev = 5;
              _iterator3.s();
            case 7:
              if ((_step3 = _iterator3.n()).done) {
                _context.next = 12;
                break;
              }
              child = _step3.value;
              return _context.delegateYield(_this.traverse(child), "t0", 10);
            case 10:
              _context.next = 7;
              break;
            case 12:
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t1 = _context["catch"](5);
              _iterator3.e(_context.t1);
            case 17:
              _context.prev = 17;
              _iterator3.f();
              return _context.finish(17);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[5, 14, 17, 20]]);
      })();
    }
  }, {
    key: "clone",
    value: function clone() {
      var newTree = new $9bf71ea28793e738$var$Tree();
      var _iterator4 = _createForOfIteratorHelper(this.traverse()),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var node = _step4.value;
          newTree.addTreeNode(node.scopeRef, node.parent.scopeRef, node.nodeToRestore);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return newTree;
    }
  }]);
  return $9bf71ea28793e738$var$Tree;
}();
var $9bf71ea28793e738$var$TreeNode = /*#__PURE__*/function () {
  function $9bf71ea28793e738$var$TreeNode(props) {
    _classCallCheck(this, $9bf71ea28793e738$var$TreeNode);
    this.children = [];
    this.contain = false;
    this.scopeRef = props.scopeRef;
  }
  _createClass($9bf71ea28793e738$var$TreeNode, [{
    key: "addChild",
    value: function addChild(node) {
      this.children.push(node);
      node.parent = this;
    }
  }, {
    key: "removeChild",
    value: function removeChild(node) {
      this.children.splice(this.children.indexOf(node), 1);
      node.parent = undefined;
    }
  }]);
  return $9bf71ea28793e738$var$TreeNode;
}();
new $9bf71ea28793e738$var$Tree();
function $f7dceffc5ad7768b$export$4e328f61c538687f() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    isTextInput = props.isTextInput,
    within = props.within;
  var state = $tyW6A$react.useRef({
    isFocused: false,
    isFocusVisible: autoFocus || $507fabe10e71c6fb$export$b9b3dfddab17db27()
  });
  var _$6nfFC$useState = $tyW6A$react.useState(false),
    _$6nfFC$useState2 = _slicedToArray(_$6nfFC$useState, 2),
    isFocused1 = _$6nfFC$useState2[0],
    setFocused = _$6nfFC$useState2[1];
  var _$6nfFC$useState3 = $tyW6A$react.useState(function () {
      return state.current.isFocused && state.current.isFocusVisible;
    }),
    _$6nfFC$useState4 = _slicedToArray(_$6nfFC$useState3, 2),
    isFocusVisibleState = _$6nfFC$useState4[0],
    setFocusVisible = _$6nfFC$useState4[1];
  var updateState = $tyW6A$react.useCallback(function () {
    return setFocusVisible(state.current.isFocused && state.current.isFocusVisible);
  }, []);
  var onFocusChange = $tyW6A$react.useCallback(function (isFocused) {
    state.current.isFocused = isFocused;
    setFocused(isFocused);
    updateState();
  }, [updateState]);
  $507fabe10e71c6fb$export$ec71b4b83ac08ec3(function (isFocusVisible) {
    state.current.isFocusVisible = isFocusVisible;
    updateState();
  }, [], {
    isTextInput: isTextInput
  });
  var _$6nfFC$useFocus = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
      isDisabled: within,
      onFocusChange: onFocusChange
    }),
    focusProps = _$6nfFC$useFocus.focusProps;
  var _$6nfFC$useFocusWithi = $9ab94262bd0047c7$export$420e68273165f4ec({
      isDisabled: !within,
      onFocusWithinChange: onFocusChange
    }),
    focusWithinProps = _$6nfFC$useFocusWithi.focusWithinProps;
  return {
    isFocused: isFocused1,
    isFocusVisible: state.current.isFocused && isFocusVisibleState,
    focusProps: within ? focusWithinProps : focusProps
  };
}
var $e6afbd83fe6ebbd2$var$FocusableContext = /*#__PURE__*/$tyW6A$react__default["default"].createContext(null);
function $e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
  var context = $tyW6A$react.useContext($e6afbd83fe6ebbd2$var$FocusableContext) || {};
  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref);
  // eslint-disable-next-line
  context.ref;
    var otherProps = _objectWithoutProperties(context, _excluded$1);
  return otherProps;
}
function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, domRef) {
  var _$6nfFC$useFocus2 = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props),
    focusProps = _$6nfFC$useFocus2.focusProps;
  var _$6nfFC$useKeyboard = $46d819fcbaf35654$export$8f71654801c2f7cd(props),
    keyboardProps = _$6nfFC$useKeyboard.keyboardProps;
  var interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(focusProps, keyboardProps);
  var domProps = $e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
  var interactionProps = props.isDisabled ? {} : domProps;
  var autoFocusRef = $tyW6A$react.useRef(props.autoFocus);
  $tyW6A$react.useEffect(function () {
    if (autoFocusRef.current && domRef.current) $6a99195332edec8b$export$80f3e147d781571c(domRef.current);
    autoFocusRef.current = false;
  }, [domRef]);
  return {
    focusableProps: $3ef42575df84b30b$export$9d1611c77c2fe928(_objectSpread2(_objectSpread2({}, interactions), {}, {
      tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
    }), interactionProps)
  };
}

function $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref) {
  var _props$elementType = props.elementType,
    elementType = _props$elementType === void 0 ? 'button' : _props$elementType,
    isDisabled = props.isDisabled,
    onPress = props.onPress,
    onPressStart = props.onPressStart,
    onPressEnd = props.onPressEnd,
    onPressChange = props.onPressChange,
    // @ts-ignore - undocumented
    preventFocusOnPress = props.preventFocusOnPress,
    // @ts-ignore - undocumented
    allowFocusWhenDisabled = props.allowFocusWhenDisabled,
    deprecatedOnClick = props.onClick,
    href = props.href,
    target = props.target,
    rel = props.rel,
    _props$type = props.type,
    type = _props$type === void 0 ? 'button' : _props$type;
  var additionalProps;
  if (elementType === 'button') additionalProps = {
    type: type,
    disabled: isDisabled
  };else additionalProps = {
    role: 'button',
    tabIndex: isDisabled ? undefined : 0,
    href: elementType === 'a' && isDisabled ? undefined : href,
    target: elementType === 'a' ? target : undefined,
    type: elementType === 'input' ? type : undefined,
    disabled: elementType === 'input' ? isDisabled : undefined,
    'aria-disabled': !isDisabled || elementType === 'input' ? undefined : isDisabled,
    rel: elementType === 'a' ? rel : undefined
  };
  var _$cE0pI$usePress = $f6c31cce2adf654f$export$45712eceda6fad21({
      onPressStart: onPressStart,
      onPressEnd: onPressEnd,
      onPressChange: onPressChange,
      onPress: onPress,
      isDisabled: isDisabled,
      preventFocusOnPress: preventFocusOnPress,
      ref: ref
    }),
    pressProps = _$cE0pI$usePress.pressProps,
    isPressed = _$cE0pI$usePress.isPressed;
  var _$cE0pI$useFocusable = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, ref),
    focusableProps = _$cE0pI$useFocusable.focusableProps;
  if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
  var buttonProps = $3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, pressProps, $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  }));
  return {
    isPressed: isPressed,
    buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(additionalProps, buttonProps, {
      'aria-haspopup': props['aria-haspopup'],
      'aria-expanded': props['aria-expanded'],
      'aria-controls': props['aria-controls'],
      'aria-pressed': props['aria-pressed'],
      onClick: function onClick(e) {
        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn('onClick is deprecated, please use onPress');
        }
      }
    })
  };
}

function $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, ref) {
  var _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    isRequired = props.isRequired,
    isReadOnly = props.isReadOnly,
    value = props.value,
    name = props.name,
    children = props.children,
    ariaLabel = props['aria-label'],
    ariaLabelledby = props['aria-labelledby'],
    _props$validationStat = props.validationState,
    validationState = _props$validationStat === void 0 ? 'valid' : _props$validationStat;
  var onChange = function onChange(e) {
    // since we spread props on label, onChange will end up there as well as in here.
    // so we have to stop propagation at the lowest level that we care about
    e.stopPropagation();
    state.setSelected(e.target.checked);
  };
  var hasChildren = children != null;
  var hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
  if (!hasChildren && !hasAriaLabel) console.warn('If you do not provide children, you must specify an aria-label for accessibility');
  // This handles focusing the input on pointer down, which Safari does not do by default.
  var _$7CUUz$usePress = $f6c31cce2adf654f$export$45712eceda6fad21({
      isDisabled: isDisabled
    }),
    pressProps = _$7CUUz$usePress.pressProps;
  var _$7CUUz$useFocusable = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, ref),
    focusableProps = _$7CUUz$useFocusable.focusableProps;
  var interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, focusableProps);
  var domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  return {
    inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, _objectSpread2({
      'aria-invalid': validationState === 'invalid' || undefined,
      'aria-errormessage': props['aria-errormessage'],
      'aria-controls': props['aria-controls'],
      'aria-readonly': isReadOnly || undefined,
      'aria-required': isRequired || undefined,
      onChange: onChange,
      disabled: isDisabled,
      value: value,
      name: name,
      type: 'checkbox'
    }, interactions))
  };
}

function $406796ff087fe49b$export$e375f10ce42261c5(props, state, inputRef) {
  var _$cKEhs$useToggle = $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, inputRef),
    inputProps = _$cKEhs$useToggle.inputProps;
  var isSelected = state.isSelected;
  var isIndeterminate = props.isIndeterminate;
  $tyW6A$react.useEffect(function () {
    // indeterminate is a property, but it can only be set via javascript
    // https://css-tricks.com/indeterminate-checkboxes/
    if (inputRef.current) inputRef.current.indeterminate = isIndeterminate;
  });
  return {
    inputProps: _objectSpread2(_objectSpread2({}, inputProps), {}, {
      checked: isSelected,
      'aria-checked': isIndeterminate ? 'mixed' : isSelected
    })
  };
}

var _excluded = ["children", "elementType", "isFocusable", "style"];
var $5c3e21d68f1c4674$var$styles = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  margin: '0 -1px -1px 0',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: 1,
  whiteSpace: 'nowrap'
};
function $5c3e21d68f1c4674$export$a966af930f325cab() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var style = props.style,
    isFocusable = props.isFocusable;
  var _$9BxnE$useState = $tyW6A$react.useState(false),
    _$9BxnE$useState2 = _slicedToArray(_$9BxnE$useState, 2),
    isFocused = _$9BxnE$useState2[0],
    setFocused = _$9BxnE$useState2[1];
  var _$9BxnE$useFocus = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
      isDisabled: !isFocusable,
      onFocusChange: setFocused
    }),
    focusProps = _$9BxnE$useFocus.focusProps;
  // If focused, don't hide the element.
  var combinedStyles = $tyW6A$react.useMemo(function () {
    if (isFocused) return style;else if (style) return _objectSpread2(_objectSpread2({}, $5c3e21d68f1c4674$var$styles), style);else return $5c3e21d68f1c4674$var$styles;
  }, [isFocused]);
  return {
    visuallyHiddenProps: _objectSpread2(_objectSpread2({}, focusProps), {}, {
      style: combinedStyles
    })
  };
}
function $5c3e21d68f1c4674$export$439d29a4e110a164(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var children = props.children,
    _props$elementType = props.elementType,
    Element = _props$elementType === void 0 ? 'div' : _props$elementType;
    props.isFocusable;
    props.style;
    var otherProps = _objectWithoutProperties(props, _excluded);
  var _$5c3e21d68f1c4674$ex = $5c3e21d68f1c4674$export$a966af930f325cab(props),
    visuallyHiddenProps = _$5c3e21d68f1c4674$ex.visuallyHiddenProps;
  return /*#__PURE__*/$tyW6A$react__default["default"].createElement(Element, $3ef42575df84b30b$export$9d1611c77c2fe928(otherProps, visuallyHiddenProps), children);
}

function $326e436e94273fe1$export$1c4b08e0eca38426(props, state) {
  var domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  var _$kgVYN$useHover = $6179b936705e76d3$export$ae780daf29e6d456({
      onHoverStart: function onHoverStart() {
        return state === null || state === void 0 ? void 0 : state.open(true);
      },
      onHoverEnd: function onHoverEnd() {
        return state === null || state === void 0 ? void 0 : state.close();
      }
    }),
    hoverProps = _$kgVYN$useHover.hoverProps;
  return {
    tooltipProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, hoverProps, {
      role: 'tooltip'
    })
  };
}
function $4e1b34546679e357$export$a6da6c504e4bba8b(props, state, ref) {
  var isDisabled = props.isDisabled,
    trigger = props.trigger;
  var tooltipId = $bdb11010cef70236$export$f680877a34711e37();
  var isHovered = $tyW6A$react.useRef(false);
  var isFocused = $tyW6A$react.useRef(false);
  var handleShow = function handleShow() {
    if (isHovered.current || isFocused.current) state.open(isFocused.current);
  };
  var handleHide = function handleHide(immediate) {
    if (!isHovered.current && !isFocused.current) state.close(immediate);
  };
  $tyW6A$react.useEffect(function () {
    var onKeyDown = function onKeyDown(e) {
      if (ref && ref.current)
        // Escape after clicking something can give it keyboard focus
        // dismiss tooltip on esc key press
        {
          if (e.key === 'Escape') state.close(true);
        }
    };
    if (state.isOpen) {
      document.addEventListener('keydown', onKeyDown, true);
      return function () {
        document.removeEventListener('keydown', onKeyDown, true);
      };
    }
  }, [ref, state]);
  var onHoverStart = function onHoverStart() {
    if (trigger === 'focus') return;
    // In chrome, if you hover a trigger, then another element obscures it, due to keyboard
    // interactions for example, hover will end. When hover is restored after that element disappears,
    // focus moves on for example, then the tooltip will reopen. We check the modality to know if the hover
    // is the result of moving the mouse.
    if ($507fabe10e71c6fb$export$630ff653c5ada6a9() === 'pointer') isHovered.current = true;else isHovered.current = false;
    handleShow();
  };
  var onHoverEnd = function onHoverEnd() {
    if (trigger === 'focus') return;
    // no matter how the trigger is left, we should close the tooltip
    isFocused.current = false;
    isHovered.current = false;
    handleHide();
  };
  var onPressStart = function onPressStart() {
    // no matter how the trigger is pressed, we should close the tooltip
    isFocused.current = false;
    isHovered.current = false;
    handleHide(true);
  };
  var onFocus = function onFocus() {
    var isVisible = $507fabe10e71c6fb$export$b9b3dfddab17db27();
    if (isVisible) {
      isFocused.current = true;
      handleShow();
    }
  };
  var onBlur = function onBlur() {
    isFocused.current = false;
    isHovered.current = false;
    handleHide(true);
  };
  var _$kgVYN$useHover2 = $6179b936705e76d3$export$ae780daf29e6d456({
      isDisabled: isDisabled,
      onHoverStart: onHoverStart,
      onHoverEnd: onHoverEnd
    }),
    hoverProps = _$kgVYN$useHover2.hoverProps;
  var _$kgVYN$usePress = $f6c31cce2adf654f$export$45712eceda6fad21({
      onPressStart: onPressStart
    }),
    pressProps = _$kgVYN$usePress.pressProps;
  var _$kgVYN$useFocusable = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c({
      isDisabled: isDisabled,
      onFocus: onFocus,
      onBlur: onBlur
    }, ref),
    focusableProps = _$kgVYN$useFocusable.focusableProps;
  return {
    triggerProps: _objectSpread2({
      'aria-describedby': state.isOpen ? tooltipId : undefined
    }, $3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, hoverProps, pressProps)),
    tooltipProps: {
      id: tooltipId
    }
  };
}

const buttonVariants = {
    primary: "primary",
    secondary: "secondary",
    tertiary: "tertiary",
};
const colorVariants = {
    dark: "dark",
    light: "light",
};
const sizeVariants = {
    default: "default",
    small: "small",
};

const getVariants = ({ colors, effects, size }) => {
    const defaultButtonStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 48,
        maxWidth: 360,
        fontSize: 16,
        fontWeight: 600,
        width: "100%",
        borderRadius: effects.rounding._4,
        transition: "all 300ms ease, border 0ms ease",
        letterSpacing: 0.4,
        cursor: "pointer",
        lineHeight: 1.5,
        textAlign: "center",
        border: 0,
        paddingTop: "12px",
        paddingBottom: "12px",
        marginLeft: 0,
        marginRight: 0,
    };
    const baseButtonStyleSmall = Object.assign(Object.assign({}, defaultButtonStyle), { padding: "8px 24px", height: "40px", width: "auto" });
    const baseButtonStyle = size === sizeVariants.small ? baseButtonStyleSmall : defaultButtonStyle;
    const primaryDark = Object.assign(Object.assign({}, baseButtonStyle), { color: colors.tone.white, bg: colors.tone.black, ":hover": {
            bg: colors.tone.anthraciteDark,
            boxShadow: `0 4px 8px 0 ${effects.overlay.black_10}`,
        }, ":focus-visible": {
            border: "solid 2px",
            borderColor: colors.semantic.blue,
        }, ":disabled": {
            bg: colors.tone.silver,
            cursor: "unset",
            boxShadow: "none",
            color: colors.tone.anthraciteLight,
        } });
    const primaryLight = Object.assign(Object.assign({}, baseButtonStyle), { bg: colors.tone.white, color: colors.tone.black, ":hover": {
            boxShadow: `0 4px 8px 0 ${effects.overlay.black_10}`,
            backgroundColor: colors.tone.marble,
        }, ":focus-visible": {
            border: "solid 2px",
            borderColor: colors.semantic.blue,
        }, ":disabled": {
            bg: colors.tone.silver,
            cursor: "unset",
            boxShadow: "none",
            color: colors.tone.anthraciteLight,
            background: effects.overlay.white_50,
        } });
    const secondaryDark = Object.assign(Object.assign({}, baseButtonStyle), { border: "2px solid", borderColor: colors.tone.black, bg: "transparent", color: colors.tone.black, ":hover": {
            backgroundColor: effects.overlay.black_10,
        }, ":focus-visible": {
            border: "solid 2px",
            borderColor: colors.semantic.blue,
        }, ":active": {
            backgroundColor: "rgba(0, 0, 0, 0.16)",
        }, ":disabled": {
            backgroundColor: "transparent",
            cursor: "unset",
            boxShadow: "none",
            color: colors.tone.anthraciteLight,
            border: "2px solid",
            borderColor: colors.tone.silver,
        } });
    const secondaryLight = Object.assign(Object.assign({}, baseButtonStyle), { border: "2px solid", borderColor: colors.tone.white, color: colors.tone.white, bg: "transparent", ":hover": {
            backgroundColor: "rgba(255, 255, 255, 0.16)",
        }, ":focus-visible": {
            border: "solid 2px",
            borderColor: colors.semantic.blue,
        }, ":active": {
            backgroundColor: "rgba(255, 255, 255, 0.32)",
        }, ":disabled": {
            backgroundColor: "transparent",
            cursor: "unset",
            boxShadow: "none",
            color: colors.tone.anthraciteLight,
            border: "2px solid",
            borderColor: colors.tone.silver,
        } });
    const tertiaryDark = Object.assign(Object.assign({}, baseButtonStyle), { bg: "rgba(0, 0, 0, 0.04)", color: "Black", ":hover": {
            backgroundColor: effects.overlay.black_10,
        }, ":focus-visible": {
            border: "solid 2px",
            borderColor: colors.semantic.blue,
        }, ":active": {
            backgroundColor: "rgba(0, 0, 0, 0.16)",
        }, ":disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
            cursor: "unset",
            boxShadow: "none",
            color: colors.tone.anthraciteLight,
        } });
    const tertiaryLight = Object.assign(Object.assign({}, baseButtonStyle), { color: "White", bg: "rgba(255, 255, 255, 0.25)", ":hover": {
            backgroundColor: effects.overlay.white_50,
        }, ":focus-visible": {
            border: "solid 2px",
            borderColor: colors.semantic.blue,
        }, ":active": {
            backgroundColor: effects.overlay.white_50,
        }, ":disabled": {
            bg: effects.overlay.white_25,
            color: colors.tone.anthraciteLight,
            cursor: "unset",
            boxShadow: "none",
        } });
    const buttonsStyles = {
        [buttonVariants.primary]: {
            [colorVariants.dark]: primaryDark,
            [colorVariants.light]: primaryLight,
        },
        [buttonVariants.secondary]: {
            [colorVariants.dark]: secondaryDark,
            [colorVariants.light]: secondaryLight,
        },
        [buttonVariants.tertiary]: {
            [colorVariants.dark]: tertiaryDark,
            [colorVariants.light]: tertiaryLight,
        },
    };
    return core.compose(buttonsStyles);
};

const StyledLabel$1 = styled__default["default"](core.Typography) `
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const StyledButton = styled__default["default"].button `
  ${({ theme, variant, colorScheme, size }) => { var _a; return (_a = getVariants(Object.assign(Object.assign({}, theme), { size }))[variant]) === null || _a === void 0 ? void 0 : _a[colorScheme]; }}
`;
const Button = (props) => {
    const ref = $tyW6A$react.useRef();
    const { buttonProps } = $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref);
    const { label, title, variant = "primary", colorScheme = "dark", size, testId, rightAlignedIcon, children, onClick } = props, rest = __rest(props, ["label", "title", "variant", "colorScheme", "size", "testId", "rightAlignedIcon", "children", "onClick"]);
    const { pressProps } = $f6c31cce2adf654f$export$45712eceda6fad21({
        onPress: onClick,
    });
    return (jsxRuntime.jsxs(StyledButton, Object.assign({ ref: ref, title: title || label, variant: variant, colorScheme: colorScheme, size: size, "data-testid": testId }, buttonProps, pressProps, rest, { children: [children && !rightAlignedIcon && children, label && jsxRuntime.jsx(StyledLabel$1, { variant: "default_semibold", children: label }), children && rightAlignedIcon && children] })));
};

const alertBannerVariants = ({ space, colors, effects }) => {
    const AlertBannerBaseStyles = {
        borderRadius: effects.rounding._8,
        padding: space._12,
        color: colors.tone.white,
        display: "flex",
        flexFlow: "row nowrap",
        alignItems: "center",
        justifyContent: "space-between",
    };
    const info = Object.assign(Object.assign({}, AlertBannerBaseStyles), { backgroundColor: colors.tone.sand, color: colors.tone.black });
    const special = Object.assign(Object.assign({}, AlertBannerBaseStyles), { backgroundColor: colors.primary.gold });
    const positive = Object.assign(Object.assign({}, AlertBannerBaseStyles), { backgroundColor: colors.semantic.green });
    const negative = Object.assign(Object.assign({}, AlertBannerBaseStyles), { backgroundColor: colors.semantic.red });
    const neutral = Object.assign(Object.assign({}, AlertBannerBaseStyles), { backgroundColor: colors.tone.white, color: colors.tone.black });
    const alertButtonStyles = {
        "info": info,
        "special": special,
        "positive": positive,
        "negative": negative,
        "neutral": neutral,
    };
    return core.compose(alertButtonStyles);
};
const StyledAlertBannerContentWrapper = styled__default["default"].div({
    display: "flex",
    alignItems: "center",
});
const StyledAlertBannerTypography = styled__default["default"](core.Typography)(({ theme }) => ({
    marginLeft: theme.space._8,
}));
const StyledCloseButton = styled__default["default"](Button)(({ theme }) => ({
    borderColor: "transparent",
    backgroundColor: "transparent",
    flexGrow: 0,
    flexShrink: 0,
    marginLeft: theme.space._8,
    minWidth: 20,
    minHeight: 20,
    padding: theme.space._8,
}));
const StyledIconWrapper = styled__default["default"].div({
    display: "inline-flex",
    flexGrow: 0,
    flexShrink: 0,
});
const StyledAlertBanner = styled__default["default"].div `
  ${({ theme, variant, }) => alertBannerVariants(theme)[variant]}
`;

const getIcon = (variant, theme) => {
    switch (variant) {
        case "positive":
            return jsxRuntime.jsx(icons.CheckCircleIcon, { color: theme.colors.tone.white, role: "presentation" });
        case "negative":
            return jsxRuntime.jsx(icons.AlertTriangleIcon, { color: theme.colors.tone.white, role: "presentation" });
        case "special":
            return jsxRuntime.jsx(icons.AlertCircleIcon, { color: theme.colors.tone.white, role: "presentation" });
        case "neutral":
        case "info":
        default:
            return jsxRuntime.jsx(icons.InfoCircleIcon, { color: theme.colors.tone.black, role: "presentation" });
    }
};
const AlertBanner = ({ testId, variant = "info", children, onClose, scrollIntoView = false, }) => {
    const ref = $tyW6A$react.useRef(null);
    const theme = react.useTheme();
    const buttonVariant = variant === "info" || variant === "neutral" ? "tertiary" : "secondary";
    const role = variant === "positive" || variant === "negative" ? "status" : undefined;
    $tyW6A$react.useEffect(() => {
        if (scrollIntoView && (variant === "positive" || variant === "negative")) {
            ref.current.scrollIntoView({ behavior: "smooth" });
        }
    }, []);
    return (jsxRuntime.jsxs(StyledAlertBanner, { ref: ref, variant: variant, "data-testid": testId, role: role, children: [jsxRuntime.jsxs(StyledAlertBannerContentWrapper, { children: [jsxRuntime.jsx(StyledIconWrapper, { children: getIcon(variant, theme) }), jsxRuntime.jsx(StyledAlertBannerTypography, { variant: "small_semibold", children: children })] }), onClose && jsxRuntime.jsx(StyledCloseButton, { size: "small", variant: buttonVariant, colorScheme: "light", title: "Close", onClick: onClose, children: jsxRuntime.jsx(icons.CloseSmallIcon, { color: "currentColor", role: "presentation" }) })] }));
};

const StyledDividerHorizontal = styled__default["default"].div(({ theme, width }) => ({
    backgroundColor: theme.colors.tone.marble,
    width: width || "100%",
    height: 1,
}));
const StyledDividerVertical = styled__default["default"].div(({ theme, height }) => ({
    backgroundColor: theme.colors.tone.marble,
    height: height || "100%",
    width: 1,
}));

const Divider = ({ variant = "horizontal", width, height, "data-testid": testId = "divider", }) => variant === "horizontal" ? (jsxRuntime.jsx(StyledDividerHorizontal, { "data-testid": testId, width: width })) : (jsxRuntime.jsx(StyledDividerVertical, { "data-testid": testId, height: height }));

function $3017fa7ffdddec74$export$8042c6c013fd5226() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isReadOnly = props.isReadOnly;
  // have to provide an empty function so useControlledState doesn't throw a fit
  // can't use useControlledState's prop calling because we need the event object from the change
  var _$bOkae$useControlled = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.isSelected, props.defaultSelected || false, props.onChange),
    _$bOkae$useControlled2 = _slicedToArray(_$bOkae$useControlled, 2),
    isSelected = _$bOkae$useControlled2[0],
    setSelected = _$bOkae$useControlled2[1];
  function updateSelected(value) {
    if (!isReadOnly) setSelected(value);
  }
  function toggleState() {
    if (!isReadOnly) setSelected(!isSelected);
  }
  return {
    isSelected: isSelected,
    setSelected: updateSelected,
    toggle: toggleState
  };
}

function $fc909762b330b746$export$61c6a8c84e605fb6(props) {
  var _$4oA3P$useControlled = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.isOpen, props.defaultOpen || false, props.onOpenChange),
    _$4oA3P$useControlled2 = _slicedToArray(_$4oA3P$useControlled, 2),
    isOpen = _$4oA3P$useControlled2[0],
    setOpen = _$4oA3P$useControlled2[1];
  return {
    isOpen: isOpen,
    setOpen: setOpen,
    open: function open() {
      setOpen(true);
    },
    close: function close() {
      setOpen(false);
    },
    toggle: function toggle() {
      setOpen(!isOpen);
    }
  };
}

var $8796f90736e175cb$var$TOOLTIP_DELAY = 1500; // this seems to be a 1.5 second delay, check with design
var $8796f90736e175cb$var$TOOLTIP_COOLDOWN = 500;
var $8796f90736e175cb$var$tooltips = {};
var $8796f90736e175cb$var$tooltipId = 0;
var $8796f90736e175cb$var$globalWarmedUp = false;
var $8796f90736e175cb$var$globalWarmUpTimeout = null;
var $8796f90736e175cb$var$globalCooldownTimeout = null;
function $8796f90736e175cb$export$4d40659c25ecb50b() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$delay = props.delay,
    delay = _props$delay === void 0 ? $8796f90736e175cb$var$TOOLTIP_DELAY : _props$delay;
  var _$1OhDq$useOverlayTri = $fc909762b330b746$export$61c6a8c84e605fb6(props),
    isOpen = _$1OhDq$useOverlayTri.isOpen,
    open = _$1OhDq$useOverlayTri.open,
    close = _$1OhDq$useOverlayTri.close;
  var id = $tyW6A$react.useMemo(function () {
    return "".concat(++$8796f90736e175cb$var$tooltipId);
  }, []);
  var closeTimeout = $tyW6A$react.useRef();
  var ensureTooltipEntry = function ensureTooltipEntry() {
    $8796f90736e175cb$var$tooltips[id] = hideTooltip;
  };
  var closeOpenTooltips = function closeOpenTooltips() {
    for (var hideTooltipId in $8796f90736e175cb$var$tooltips) if (hideTooltipId !== id) {
      $8796f90736e175cb$var$tooltips[hideTooltipId](true);
      delete $8796f90736e175cb$var$tooltips[hideTooltipId];
    }
  };
  var showTooltip = function showTooltip() {
    clearTimeout(closeTimeout.current);
    closeTimeout.current = null;
    closeOpenTooltips();
    ensureTooltipEntry();
    $8796f90736e175cb$var$globalWarmedUp = true;
    open();
    if ($8796f90736e175cb$var$globalWarmUpTimeout) {
      clearTimeout($8796f90736e175cb$var$globalWarmUpTimeout);
      $8796f90736e175cb$var$globalWarmUpTimeout = null;
    }
    if ($8796f90736e175cb$var$globalCooldownTimeout) {
      clearTimeout($8796f90736e175cb$var$globalCooldownTimeout);
      $8796f90736e175cb$var$globalCooldownTimeout = null;
    }
  };
  var hideTooltip = function hideTooltip(immediate) {
    if (immediate) {
      clearTimeout(closeTimeout.current);
      closeTimeout.current = null;
      close();
    } else if (!closeTimeout.current) closeTimeout.current = setTimeout(function () {
      closeTimeout.current = null;
      close();
    }, $8796f90736e175cb$var$TOOLTIP_COOLDOWN);
    if ($8796f90736e175cb$var$globalWarmUpTimeout) {
      clearTimeout($8796f90736e175cb$var$globalWarmUpTimeout);
      $8796f90736e175cb$var$globalWarmUpTimeout = null;
    }
    if ($8796f90736e175cb$var$globalWarmedUp) {
      if ($8796f90736e175cb$var$globalCooldownTimeout) clearTimeout($8796f90736e175cb$var$globalCooldownTimeout);
      $8796f90736e175cb$var$globalCooldownTimeout = setTimeout(function () {
        delete $8796f90736e175cb$var$tooltips[id];
        $8796f90736e175cb$var$globalCooldownTimeout = null;
        $8796f90736e175cb$var$globalWarmedUp = false;
      }, $8796f90736e175cb$var$TOOLTIP_COOLDOWN);
    }
  };
  var warmupTooltip = function warmupTooltip() {
    closeOpenTooltips();
    ensureTooltipEntry();
    if (!isOpen && !$8796f90736e175cb$var$globalWarmUpTimeout && !$8796f90736e175cb$var$globalWarmedUp) $8796f90736e175cb$var$globalWarmUpTimeout = setTimeout(function () {
      $8796f90736e175cb$var$globalWarmUpTimeout = null;
      $8796f90736e175cb$var$globalWarmedUp = true;
      showTooltip();
    }, delay);else if (!isOpen) showTooltip();
  };
  // eslint-disable-next-line arrow-body-style
  $tyW6A$react.useEffect(function () {
    return function () {
      clearTimeout(closeTimeout.current);
      var tooltip = $8796f90736e175cb$var$tooltips[id];
      if (tooltip) delete $8796f90736e175cb$var$tooltips[id];
    };
  }, [id]);
  return {
    isOpen: isOpen,
    open: function open(immediate) {
      if (!immediate && delay > 0 && !closeTimeout.current) warmupTooltip();else showTooltip();
    },
    close: hideTooltip
  };
}

const Container = styled__default["default"].label(({ isDisabled, theme: { typography } }) => ({
    opacity: isDisabled ? 0.5 : 1,
    fontFamily: typography.fontFamily.SSP,
    fontSize: typography.fontSize._16,
    "&:hover": {
        cursor: isDisabled ? "unset" : "pointer"
    }
}));
const BoxArea = styled__default["default"].div(({ theme: { colors, space }, isFocusVisible, isSelected, hasError }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: space._16,
    width: space._16,
    marginTop: "2px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "2px",
    flex: "0 0 auto",
    transition: "border 200ms ease-in-out",
    borderColor: (() => {
        if (hasError)
            return colors.semantic.red;
        if (isFocusVisible)
            return colors.semantic.blue;
        if (isSelected)
            return colors.tone.black;
        return colors.tone.silver;
    })(),
}));
const Label$1 = styled__default["default"].div(() => ({
    display: "flex",
}));
const Indicator = styled__default["default"].div(({ isSelected, isIndeterminate, theme: { space, colors } }) => ({
    height: space._8,
    width: space._8,
    borderRadius: "1px",
    backgroundColor: colors.tone.black,
    transform: (() => {
        let scale = [0, 0];
        if (isSelected)
            scale = [1, 1];
        if (isIndeterminate)
            scale = [1, 0.25];
        return `scale(${scale.join(", ")})`;
    })(),
}));
const ErrorMessage = styled__default["default"].div(({ theme: { colors, typography, space } }) => ({
    color: colors.semantic.red,
    fontSize: typography.fontSize._14,
    marginTop: space._8,
}));
const Wrapper = styled__default["default"].div(({ theme: { space, colors }, isFocusVisible, hasError, isDisabled }) => ({
    display: "inline-flex",
    alignItems: "start",
    gap: space._8,
    [`&:hover ${BoxArea}`]: (() => {
        return {
            borderColor: (() => {
                if (hasError || isFocusVisible || isDisabled)
                    return undefined;
                return colors.tone.black;
            })(),
        };
    })(),
}));

const Checkbox = (props) => {
    const { isIndeterminate, isDisabled, children, errorMessage, wrapperProps } = props;
    const state = $3017fa7ffdddec74$export$8042c6c013fd5226(props);
    const ref = $tyW6A$react__default["default"].useRef();
    const { inputProps } = $406796ff087fe49b$export$e375f10ce42261c5(props, state, ref);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    const isSelected = state.isSelected && !isIndeterminate;
    return (jsxRuntime.jsxs(Container, Object.assign({}, wrapperProps, { isDisabled: isDisabled, children: [jsxRuntime.jsx($5c3e21d68f1c4674$export$439d29a4e110a164, { children: jsxRuntime.jsx("input", Object.assign({}, inputProps, focusProps, { ref: ref })) }), jsxRuntime.jsxs(Wrapper, { isFocusVisible: isFocusVisible, hasError: !!errorMessage, isDisabled: isDisabled, children: [jsxRuntime.jsx(BoxArea, { isFocusVisible: isFocusVisible, hasError: !!errorMessage, isSelected: isSelected, children: jsxRuntime.jsx(Indicator, { isSelected: isSelected, isIndeterminate: isIndeterminate }) }), jsxRuntime.jsx(Label$1, { children: children })] }), errorMessage && jsxRuntime.jsx(ErrorMessage, { children: errorMessage })] })));
};

const StyledLabel = styled__default["default"].div(({ theme, variant, backgroundColor, textColor }) => (Object.assign({ color: textColor || theme.colors.tone.black, width: "fit-content", maxWidth: 272, borderRadius: theme.space._4, display: "inline-block" }, (variant === "solid"
    ? {
        backgroundColor: backgroundColor || theme.colors.tone.sand,
        padding: `${theme.space._4} ${theme.space._8} ${theme.space._4} ${theme.space._8}`,
    }
    : {}))));

const Label = ({ children, "data-testid": testId = "label", ariaDescription, variant = "solid", backgroundColor, textColor, }) => {
    const ariaDescriptionId = nanoid.nanoid();
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(StyledLabel, { "data-testid": testId, variant: variant, backgroundColor: backgroundColor, textColor: textColor, children: jsxRuntime.jsx(core.Typography, Object.assign({}, (ariaDescription
                    ? { "aria-describedby": ariaDescriptionId }
                    : {}), { variant: "xsmall_semibold", children: children })) }), ariaDescription && (jsxRuntime.jsx($5c3e21d68f1c4674$export$439d29a4e110a164, { children: jsxRuntime.jsx("p", { id: ariaDescriptionId, children: ariaDescription }) }))] }));
};

const StyledListItem = styled__default["default"].li(({ theme }) => ({
    height: theme.space._48,
    listStyle: "none",
    boxShadow: `inset 0px -1px 0px ${theme.colors.tone.marble}`,
}));

const ListItem = ({ children, "data-testid": testId = "listItem", }) => jsxRuntime.jsx(StyledListItem, { "data-testid": testId, children: children });

const TooltipText = styled__default["default"].div(({ position = "top", variant = "white", maxWidth = 260, theme: { typography, colors }, }) => (Object.assign(Object.assign(Object.assign(Object.assign({ boxSizing: "border-box", position: "absolute", maxWidth, minWidth: 120, width: "max-content", backgroundColor: variant === "white" ? colors.tone.white : colors.tone.black, color: variant === "white" ? colors.tone.black : colors.tone.white, textAlign: "center", padding: "12px 16px", fontFamily: typography.fontFamily.SSP, fontSize: typography.fontSize._14, borderRadius: 4, boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", zIndex: 2 }, (position === "top" && {
    left: "50%",
    bottom: "100%",
    transform: "translateX(-50%)",
    marginBottom: 11,
})), (position === "right" && {
    left: "100%",
    top: "50%",
    transform: "translateY(-50%)",
    marginLeft: 14,
})), (position === "bottom" && {
    left: "50%",
    top: "100%",
    transform: "translateX(-50%)",
    marginTop: 11,
})), (position === "left" && {
    right: "100%",
    top: "50%",
    transform: "translateY(-50%)",
    marginRight: 14,
}))));
const TolltipLabel = styled__default["default"].div(({ maxHeight = 54 }) => ({
    overflow: "hidden",
    maxHeight,
}));
const TooltipTip = styled__default["default"].div(({ position = "top", variant = "white", theme }) => (Object.assign(Object.assign(Object.assign(Object.assign({ position: "absolute", "> svg": {
        display: "block",
        fill: variant === "white" ? theme.colors.tone.white : theme.colors.tone.black,
    } }, (position === "top" && {
    top: "100%",
    left: "50%",
    transform: "translateX(-50%)",
})), (position === "right" && {
    top: "50%",
    right: "100%",
    transform: "translate(0%, -50%)",
})), (position === "bottom" && {
    bottom: "100%",
    left: "50%",
    transform: "translateX(-50%)",
})), (position === "left" && {
    top: "50%",
    left: "100%",
    transform: "translate(0%, -50%)",
}))));

const Tooltip = (_a) => {
    var { state } = _a, props = __rest(_a, ["state"]);
    const { tooltipProps } = $326e436e94273fe1$export$1c4b08e0eca38426(props, state);
    return (jsxRuntime.jsxs(TooltipText, Object.assign({}, $3ef42575df84b30b$export$9d1611c77c2fe928(props, tooltipProps), { children: [jsxRuntime.jsx(TolltipLabel, { maxHeight: props.maxHeight, children: props.children }), jsxRuntime.jsxs(TooltipTip, { variant: props.variant, position: props.position, children: [props.position === "top" && (jsxRuntime.jsx("svg", { width: "23", height: "6", viewBox: "0 0 23 6", fill: "none", id: "top", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntime.jsx("path", { d: "M9.73415 5.33805L6.32325 2.34893C4.57046 0.812892 2.55521 0 0.5 0H22.5C20.4422 0 18.4219 0.787471 16.6482 2.28085L12.9687 5.3789C11.968 6.22146 10.7243 6.20575 9.73415 5.33805Z" }) })), props.position === "bottom" && (jsxRuntime.jsx("svg", { width: "23", height: "6", viewBox: "0 0 23 6", fill: "none", id: "bottom", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntime.jsx("path", { d: "M13.2658 0.661955L16.6768 3.65107C18.4295 5.18711 20.4448 6 22.5 6L0.5 6C2.55777 6 4.57813 5.21253 6.35179 3.71915L10.0313 0.621096C11.032 -0.221463 12.2757 -0.205753 13.2658 0.661955Z" }) })), props.position === "right" && (jsxRuntime.jsx("svg", { width: "6", height: "22", viewBox: "0 0 6 22", fill: "none", id: "right", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntime.jsx("path", { d: "M0.661955 9.23415L3.65107 5.82325C5.18711 4.07046 6 2.05521 6 0L6 22C6 19.9422 5.21253 17.9219 3.71915 16.1482L0.621096 12.4687C-0.221463 11.468 -0.205753 10.2243 0.661955 9.23415Z" }) })), props.position === "left" && (jsxRuntime.jsx("svg", { width: "6", height: "22", viewBox: "0 0 6 22", fill: "none", id: "left", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntime.jsx("path", { d: "M5.33805 12.7658L2.34893 16.1768C0.812892 17.9295 0 19.9448 0 22L0 0C0 2.05777 0.787471 4.07813 2.28085 5.85179L5.3789 9.5313C6.22146 10.532 6.20575 11.7757 5.33805 12.7658Z" }) }))] })] })));
};
const TooltipTrigger = (p) => {
    const defaults = { delay: 500 };
    const props = Object.assign(Object.assign({}, defaults), p);
    const state = $8796f90736e175cb$export$4d40659c25ecb50b(props);
    const ref = $tyW6A$react__default["default"].useRef();
    const { triggerProps, tooltipProps } = $4e1b34546679e357$export$a6da6c504e4bba8b(props, state, ref);
    const { longPressProps } = $8a26561d2877236e$export$c24ed0104d07eab9({
        isDisabled: p.disableTouchListener,
        onLongPressEnd: () => state.open(true),
    });
    return (jsxRuntime.jsxs("span", Object.assign({ ref: ref }, $3ef42575df84b30b$export$9d1611c77c2fe928(triggerProps, longPressProps), { "data-testid": props["data-testid"], style: { position: "relative" }, tabIndex: 0, children: [props.children, state.isOpen && (jsxRuntime.jsx(Tooltip, Object.assign({ state: state, variant: props.variant, position: props.position, maxHeight: props.maxHeight, maxWidth: props.maxWidth }, tooltipProps, { children: props.tooltip })))] })));
};

const Text = $tyW6A$react.forwardRef((_a, ref) => {
    var { as = "p" } = _a, props = __rest(_a, ["as"]);
    return (jsxRuntime.jsx(core.Box, Object.assign({ ref: ref, as: as, tx: "text" }, props)));
});
Text.displayName = "Text";

const Heading = $tyW6A$react.forwardRef((_a, ref) => {
    var { as = "h2" } = _a, props = __rest(_a, ["as"]);
    return (jsxRuntime.jsx(core.Box, Object.assign({ ref: ref, as: as, tx: "text" }, props)));
});
Heading.displayName = "Heading";

const FormInput = $tyW6A$react.forwardRef((_a, ref) => {
    var { as = "input" } = _a, props = __rest(_a, ["as"]);
    return (jsxRuntime.jsx(core.Box, Object.assign({ ref: ref, as: as, tx: "forms", variant: "input" }, props)));
});
FormInput.displayName = "FormInput";

const FormLabel = $tyW6A$react.forwardRef((_a, ref) => {
    var { as = "label" } = _a, props = __rest(_a, ["as"]);
    return (jsxRuntime.jsx(core.Box, Object.assign({ ref: ref, as: as, tx: "forms", variant: "label" }, props)));
});
FormLabel.displayName = "FormLabel";

exports.AlertBanner = AlertBanner;
exports.Button = Button;
exports.Checkbox = Checkbox;
exports.Divider = Divider;
exports.FormInput = FormInput;
exports.FormLabel = FormLabel;
exports.Heading = Heading;
exports.Label = Label;
exports.ListItem = ListItem;
exports.Text = Text;
exports.Tooltip = TooltipTrigger;
